import { capitalize } from "lodash";

/*
This function is used to extract the text content from a text row and support the migration from Graphql to GROQ.
The Graphql queries have mapped fields, and some fields are prefixed with raw, and we map those with _rawContent.
In GROQ, we just get the "content" field. 
This is used on content and description fields, since those are the most commonly prefixed with _fieldNameRaw.

We have other fields in the schema that follow the pattern of fieldName and fieldNameRaw, but we explicitly map those in Graphql already (ie: headerPortableText in swipeCarouselFragment)

The function is meant to be backwards compatible with the Graphql queries and new GROQ Queries.
*/
export const extractTextContent = (
  textRow?:
    | (Record<string, any> & {
        content?: any[] | null;
        _rawContent?: any[] | null;
        description?: any[] | null;
        _rawDescription?: any[] | null;
      })
    | null,
  key: "content" | "description" = "content",
) => {
  if (!textRow) return null;
  if (typeof textRow !== "object") return textRow;

  const rawKey = `_raw${capitalize(key)}`;
  // If "content" exists in object, we return that content
  if (key in textRow && textRow[key]) {
    return textRow[key];
  }
  // If raw key exists in object, we return that raw content
  if (rawKey in textRow) {
    return textRow[rawKey];
  }
  // But this returns an array, it does not return the value
  return null;
};
